var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBar && (_vm.hasProducts || _vm.alwaysShown)
    ? _c(
        "q-toolbar",
        {
          staticClass: "footer-bar",
          attrs: {
            id: "footer-total-toolbar",
            "data-test": _vm.CypressTarget("TicketsTotalToolbar"),
            color: _vm.SET_COLOR.primary
          }
        },
        [
          _vm.hasProducts
            ? _c(
                "q-toolbar-title",
                {
                  staticClass: "footer-title",
                  attrs: { "data-test": _vm.CypressTarget("Title") }
                },
                [
                  _c("div", { staticClass: "SimpleLine" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.isFreeSale ? _vm.$t("label.total") + ":" : ""
                        ) +
                        "\n      " +
                        _vm._s(_vm.totalPrice) +
                        "\n      "
                    ),
                    _vm.labelSubTitle
                      ? _c("span", {
                          attrs: { slot: "subtitle" },
                          domProps: { textContent: _vm._s(_vm.labelSubTitle) },
                          slot: "subtitle"
                        })
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _vm.hasProducts
            ? _c("buy-button", {
                directives: [
                  {
                    name: "track-click",
                    rawName: "v-track-click:button",
                    value: {
                      category: "Navegação",
                      label: "Comprar e Ir para Carrinho"
                    },
                    expression:
                      "{category: 'Navegação', label: 'Comprar e Ir para Carrinho'}",
                    arg: "button"
                  }
                ],
                attrs: {
                  "free-sale": _vm.isFreeSale,
                  disable: _vm.loading,
                  color: _vm.SET_COLOR.buttons.buy,
                  "text-color": _vm.SET_COLOR_BUTTON.text.buy,
                  flat: _vm.SET_COLOR_BUTTON.flat.buy
                },
                on: {
                  addToCart: function($event) {
                    _vm.$emit("addToCart")
                  }
                }
              })
            : _c("transparent-fill-button")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }